import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const RideDetailsPanelContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-details-panel-container",
  },
)`
  width: 100%;
  position: relative;
  overflow: visible !important;
`;

export const RideDetailsPanelStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-details-map-panel",
})`
  width: calc(100vw - 86px);
  inset-inline-start: 0;
  position: sticky;
  margin-inline-start: 3px;
  padding: 10px;
  min-height: 200px;
  background-color: ${greyMui._300};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  .column_icons {
    margin-inline-end: 15px;
  }

  .column_bin {
    margin-inline-end: 16px;
  }

  .column_bin + span {
    margin-inline-end: 12px;
  }

  .column_toggle_h {
    margin-inline-end: 12px;
  }
`;

export const RideDetailsMapStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-details-map",
})`
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${rydeColors.smoke};
`;
